import React from 'react'
import Features from "./Features";
import LandingComponent from "./LandingComponent";
import Punchline from "./Punchline";
import SEO from "./SEO";

const Landing = () => {
  return (
    <div>
      <SEO
        title="Pathyacharya by Schooglink - बिहार बोर्ड, UP बोर्ड पढ़ाई ऐप | Hindi Medium"
        description="Schooglink delivers affordable, AI-powered vernacular education for K-12 students in rural India. Pathyacharya app - बिहार बोर्ड, UP बोर्ड, झारखंड बोर्ड परीक्षा की तैयारी हिंदी में।"
        url="https://schooglink.com/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Schooglink",
          "url": "https://schooglink.com",
          "logo": "https://schooglink.com/logo.png",
          "description": "Schooglink delivers affordable and quality education using an AI powered, vernacular learning platform for K-12 students in rural India.",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN"
          }
        }}
      />
      <LandingComponent />
      <Punchline />
      <Features />
    </div>
  )
}

export default Landing